import { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, CalendarDays, Menu, X, LogOut } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import NotificationBell from "@/components/shared/NotificationBell";
import WhatsAppButton from "@/components/layout/WhatsAppButton";

const MENU = [
  { to: "/panel-pembimbing", label: "Dashboard", icon: LayoutDashboard, exact: true },
  { to: "/panel-pembimbing/jamaah", label: "Jamaah Saya", icon: Users },
  { to: "/panel-pembimbing/manasik", label: "Manasik & Kehadiran", icon: CalendarDays },
];

function SidebarContent({ onNavigate }) {
  return (
    <nav className="flex flex-col gap-1 p-4" data-testid="guide-sidebar-nav">
      {MENU.map((m) => (
        <NavLink key={m.to} to={m.to} end={m.exact} onClick={onNavigate} data-testid={`guide-sidebar-${m.label.toLowerCase().replace(/\s+/g, "-")}`}
          className={({ isActive }) => `flex items-center gap-3 rounded-xl px-3.5 py-2.5 text-sm font-medium transition-colors ${isActive ? "bg-[#0F6B4F] text-white" : "text-[#1F2937] hover:bg-[#0F6B4F]/8"}`}>
          <m.icon className="h-4 w-4 shrink-0" /> {m.label}
        </NavLink>
      ))}
    </nav>
  );
}

export default function GuideLayout() {
  const { user, logout } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen bg-[#F5F9F7]" data-testid="guide-layout">
      <aside className="hidden w-64 shrink-0 border-r border-slate-100 bg-white lg:block">
        <div className="flex h-16 items-center gap-2 border-b border-slate-100 px-5">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-[#0F6B4F] to-[#1677B8] text-white font-heading font-bold">K</div>
          <span className="font-heading text-base font-bold text-[#1F2937]">Panel Pembimbing</span>
        </div>
        <SidebarContent />
      </aside>

      <div className="flex flex-1 flex-col">
        <header className="flex h-16 items-center justify-between gap-4 border-b border-slate-100 bg-white px-4 sm:px-6">
          <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
            <SheetTrigger asChild>
              <button className="lg:hidden" data-testid="guide-mobile-menu-toggle" aria-label="Menu"><Menu className="h-5 w-5 text-[#1F2937]" /></button>
            </SheetTrigger>
            <SheetContent side="left" className="w-72 bg-white p-0">
              <div className="flex h-16 items-center justify-between border-b border-slate-100 px-5">
                <span className="font-heading text-base font-bold text-[#1F2937]">Panel Pembimbing</span>
                <button onClick={() => setMobileOpen(false)} data-testid="guide-mobile-menu-close"><X className="h-5 w-5" /></button>
              </div>
              <SidebarContent onNavigate={() => setMobileOpen(false)} />
            </SheetContent>
          </Sheet>
          <span className="font-heading text-sm font-semibold text-[#1F2937] lg:hidden">Panel Pembimbing</span>
          <div className="flex items-center gap-3">
            <NotificationBell />
            <div className="flex items-center gap-2 border-l border-slate-100 pl-3">
              <p className="hidden text-sm font-medium text-[#1F2937] sm:block" data-testid="guide-user-name">{user?.name}</p>
              <Button variant="ghost" size="icon" data-testid="guide-logout-button" onClick={() => logout().then(() => navigate("/"))} className="text-[#64748B] hover:text-red-600">
                <LogOut className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </header>
        <main className="flex-1 overflow-x-hidden p-4 sm:p-6"><Outlet /></main>
      </div>
      <WhatsAppButton label="Hubungi Jamaah" message="Assalamu'alaikum, ada informasi manasik yang perlu saya sampaikan." />
    </div>
  );
}
